import React from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel.jsx';
import ListadoKpisHatos from './ListadoKpisHatos';
const KpisHatos = () => {
		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item"><Link to="/">KPIs por hato</Link></li>
					<li className="breadcrumb-item active">Active Page</li>
				</ol>  
				<h1 className="page-header">KPIs por hato</h1>
				<Panel>
					<PanelHeader></PanelHeader>
					<PanelBody>
					<div className="row">
						<div className="col-md-12" style={{borderRight : '2px solid #dadada'}}>
							<ListadoKpisHatos />
						</div>
					</div>
					</PanelBody>
				</Panel>
			</div>
		)
};

export default KpisHatos;